import React, { Component } from 'react';

import { Row, Col,Card} from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';
import LazyLoad from 'react-lazyload';
import Carousel from 'react-bootstrap/Carousel'

// CSS Files
import "../../Fonts/Fonts.css";
import "../../Statics/Common/FontStyle.css";
import "../../Statics/HomePage/Clients.css";

// Images
import clientOne        from "../../Imgs/HomePage/Clients/client1.png";
import clientTwo        from "../../Imgs/HomePage/Clients/client2.png";
import clientThree      from "../../Imgs/HomePage/Clients/client3.png";
import clientFour       from "../../Imgs/HomePage/Clients/client4.png";
import clientFive       from "../../Imgs/HomePage/Clients/client5.png";
import clientSix        from "../../Imgs/HomePage/Clients/client6.png";
import clientSeven      from "../../Imgs/HomePage/Clients/client7.png";
import clientEight      from "../../Imgs/HomePage/Clients/client8.png";
import clientNine       from "../../Imgs/HomePage/Clients/client9.png";
import clientTen        from "../../Imgs/HomePage/Clients/client10.jpg";
import clientEleven     from "../../Imgs/HomePage/Clients/client11.png";
import clientTwelve     from "../../Imgs/HomePage/Clients/client12.png";
import clientThirteen   from "../../Imgs/HomePage/Clients/client13.png";
import clientFourteen   from "../../Imgs/HomePage/Clients/client14.svg";
import clientFivteen    from "../../Imgs/HomePage/Clients/client15.jpg";
import clientSixteen    from "../../Imgs/HomePage/Clients/client16.jpg";

const mobileCard ={
    borderRadius:"20px"
}

const Clients = props => {
     return props.size === "laptopdesktop" ? (
        <div style={{ backgroundColor: "#ffffff" }}>
            <Center>
                <Margin top={4}>
                     <p className="subTitle"><strong>بیمه های طرف قرارداد</strong></p>
                </Margin>
            </Center>
            <Center>
                 <div className="subTitleHR"></div>
            </Center>
            <Card style={{border:"none" , backgroundColor:"#f6f6f6" , marginTop:"2.5%"}}>                       
                <Margin top={3}></Margin>
                <Row>
                    <Col span={3}></Col>
                    <Col span={18}>
                        <div className="clientsSlider">
                                <div className="clientsSlideTrack">
                                    <div className="clientsSlide">
                                     <LazyLoad>
                                         <img className="clientSliderImg" src={clientOne} alt="" />

                                     </LazyLoad>
                                    </div>
                                    <div className="clientsSlide">
                                     <LazyLoad>
                                         <img className="clientSliderImg" src={clientTwo} alt="" />

                                     </LazyLoad>
                                    </div>
                                    <div className="clientsSlide">
                                     <LazyLoad>
                                         <img className="clientSliderImg" src={clientThree} alt="" />

                                     </LazyLoad>
                                    </div>
                                    <div className="clientsSlide">
                                     <LazyLoad>
                                         <img className="clientSliderImg" src={clientFour} alt="" />

                                     </LazyLoad>
                                    </div>
                                    <div className="clientsSlide">
                                     <LazyLoad>
                                         <img className="clientSliderImg" src={clientFive} alt="" />

                                     </LazyLoad>
                                    </div>
                                    <div className="clientsSlide">
                                     <LazyLoad>
                                         <img className="clientSliderImg" src={clientSix} alt="" />

                                     </LazyLoad>
                                    </div>
                                    <div className="clientsSlide">
                                     <LazyLoad>
                                         <img className="clientSliderImg" src={clientSeven} alt="" />

                                     </LazyLoad>
                                    </div>
                                    <div className="clientsSlide">
                                     <LazyLoad>
                                         <img className="clientSliderImg" src={clientEight} alt="" />

                                     </LazyLoad>
                                    </div>
                                    <div className="clientsSlide">
                                     <LazyLoad>
                                         <img className="clientSliderImg" src={clientNine} alt="" />

                                     </LazyLoad>
                                    </div>
                                    <div className="clientsSlide">
                                     <LazyLoad>
                                         <img className="clientSliderImg" src={clientTen} alt="" />

                                     </LazyLoad>
                                    </div>
                                    <div className="clientsSlide">
                                     <LazyLoad>
                                         <img className="clientSliderImg" src={clientEleven} alt="" />

                                     </LazyLoad>
                                    </div>
                                    <div className="clientsSlide">
                                     <LazyLoad>
                                         <img className="clientSliderImg" src={clientTwelve} alt="" />

                                     </LazyLoad>
                                    </div>
                                    <div className="clientsSlide">
                                     <LazyLoad>
                                         <img className="clientSliderImg" src={clientThirteen} alt="" />

                                     </LazyLoad>
                                    </div>
                                    <div className="clientsSlide">
                                     <LazyLoad>
                                         <img className="clientSliderImg" src={clientFourteen} alt="" />

                                     </LazyLoad>
                                    </div>
                                    <div className="clientsSlide">
                                        <LazyLoad>
                                            <img className="clientSliderImg" src={clientFivteen} alt="" />

                                        </LazyLoad>
                                    </div>
                                    <div className="clientsSlide">
                                        <LazyLoad>
                                            <img className="clientSliderImg" src={clientSixteen} alt="" />

                                        </LazyLoad>
                                    </div>
                                </div>
                        </div>
                    </Col>
                    <Col span={3}></Col>
                </Row>
                <Margin bottom={3}></Margin> 
            </Card>
        </div>
     ) : props.size === "tablet" ? (
             <div style={{ backgroundColor: "#ffffff" }}>
                 <Center>
                     <Margin top={4}>
                         <p className="subTitleTablet"><strong>بیمه های طرف قرارداد</strong></p>
                     </Margin>
                 </Center>
                 <Center>
                     <hr className="subTitleHRTablet" />
                 </Center>
                 <Card style={{ borderTop: "none" }}>
                     <Margin top={3}></Margin>
                     <Row>
                         <Col span={3}></Col>
                         <Col span={18}>
                             <div className="clientsSlider">
                                 <div className="clientsSlideTrack">
                                     <div className="clientsSlide">
                                         <LazyLoad>
                                             <img className="clientSliderImg" src={clientOne} alt="" />

                                         </LazyLoad>
                                     </div>
                                     <div className="clientsSlide">
                                         <LazyLoad>
                                             <img className="clientSliderImg" src={clientTwo} alt="" />

                                         </LazyLoad>
                                     </div>
                                     <div className="clientsSlide">
                                         <LazyLoad>
                                             <img className="clientSliderImg" src={clientThree} alt="" />

                                         </LazyLoad>
                                     </div>
                                     <div className="clientsSlide">
                                         <LazyLoad>
                                             <img className="clientSliderImg" src={clientFour} alt="" />

                                         </LazyLoad>
                                     </div>
                                     <div className="clientsSlide">
                                         <LazyLoad>
                                             <img className="clientSliderImg" src={clientFive} alt="" />

                                         </LazyLoad>
                                     </div>
                                     <div className="clientsSlide">
                                         <LazyLoad>
                                             <img className="clientSliderImg" src={clientSix} alt="" />

                                         </LazyLoad>
                                     </div>
                                     <div className="clientsSlide">
                                         <LazyLoad>
                                             <img className="clientSliderImg" src={clientSeven} alt="" />

                                         </LazyLoad>
                                     </div>
                                     <div className="clientsSlide">
                                         <LazyLoad>
                                             <img className="clientSliderImg" src={clientEight} alt="" />

                                         </LazyLoad>
                                     </div>
                                     <div className="clientsSlide">
                                         <LazyLoad>
                                             <img className="clientSliderImg" src={clientNine} alt="" />

                                         </LazyLoad>
                                     </div>
                                     <div className="clientsSlide">
                                         <LazyLoad>
                                             <img className="clientSliderImg" src={clientTen} alt="" />

                                         </LazyLoad>
                                     </div>
                                     <div className="clientsSlide">
                                         <LazyLoad>
                                             <img className="clientSliderImg" src={clientEleven} alt="" />

                                         </LazyLoad>
                                     </div>
                                     <div className="clientsSlide">
                                         <LazyLoad>
                                             <img className="clientSliderImg" src={clientTwelve} alt="" />

                                         </LazyLoad>
                                     </div>
                                     <div className="clientsSlide">
                                         <LazyLoad>
                                             <img className="clientSliderImg" src={clientThirteen} alt="" />

                                         </LazyLoad>
                                     </div>
                                     <div className="clientsSlide">
                                         <LazyLoad>
                                             <img className="clientSliderImg" src={clientFourteen} alt="" />

                                         </LazyLoad>
                                     </div>
                                     <div className="clientsSlide">
                                         <LazyLoad>
                                             <img className="clientSliderImg" src={clientFivteen} alt="" />

                                         </LazyLoad>
                                     </div>
                                     <div className="clientsSlide">
                                         <LazyLoad>
                                             <img className="clientSliderImg" src={clientSixteen} alt="" />

                                         </LazyLoad>
                                     </div>
                                 </div>
                             </div>
                         </Col>
                         <Col span={3}></Col>
                     </Row>
                     <Margin bottom={3}></Margin>
                 </Card>
             </div>
     ) : (
            <div>
                <Center>
                    <p className="subTitleMobile"><strong>بیمه های طرف قرارداد</strong></p>
                </Center>
                <Center>
                    <div className="subTitleHRMobile"></div>
                </Center>
                <Row>
                    <Col span={3}></Col>
                    <Col span={18}>
                    <Carousel>
                                 <Carousel.Item>
                                    <Card style={mobileCard}>
                                         <Center>
                                             <img
                                                 className="cardImageStyle"
                                                 src={clientOne}
                                             />
                                         </Center>
                                    </Card>
                                    
                                 </Carousel.Item>
                                 <Carousel.Item>
                                     <Card style={mobileCard}>
                                         <Center>
                                             <img
                                                 className="cardImageStyle"
                                                 src={clientTwo}
                                             />
                                         </Center>
                                     </Card>

                                    
                                 </Carousel.Item>
                                 <Carousel.Item>
                                     <Card style={mobileCard}>
                                         <Center>
                                             <img
                                                 className="cardImageStyle"
                                                 src={clientThree}
                                             />
                                         </Center>
                                     </Card>

                                    
                                 </Carousel.Item>
                                 <Carousel.Item>
                                     <Card style={mobileCard}>
                                         <Center>
                                             <img
                                                 className="cardImageStyle"
                                                 src={clientFour}
                                             />
                                         </Center>
                                     </Card>

                                 </Carousel.Item>
                                 <Carousel.Item>
                                     <Card style={mobileCard}>
                                         <Center>
                                             <img
                                                 className="cardImageStyle"
                                                 src={clientFive}
                                             />
                                         </Center>
                                     </Card>

                                 </Carousel.Item>
                                 <Carousel.Item>
                                     <Card style={mobileCard}>
                                         <Center>
                                             <img
                                                 className="cardImageStyle"
                                                 src={clientSix}
                                             />
                                         </Center>
                                     </Card>

                                 </Carousel.Item>
                                 <Carousel.Item>
                                     <Card style={mobileCard}>
                                         <Center>
                                             <img
                                                 className="cardImageStyle"
                                                 src={clientSeven}
                                             />
                                         </Center>
                                     </Card>

                                 </Carousel.Item>
                                 <Carousel.Item>
                                     <Card style={mobileCard}>
                                         <Center>
                                             <img
                                                 className="cardImageStyle"
                                                 src={clientEight}
                                             />
                                         </Center>
                                     </Card>

                                 </Carousel.Item>
                                 <Carousel.Item>
                                     <Card style={mobileCard}>
                                         <Center>
                                             <img
                                                 className="cardImageStyle"
                                                 src={clientNine}
                                             />
                                         </Center>
                                     </Card>

                                 </Carousel.Item>
                                 <Carousel.Item>
                                     <Card style={mobileCard}>
                                         <Center>
                                             <img
                                                 className="cardImageStyle"
                                                 src={clientTen}
                                             />
                                         </Center>
                                     </Card>

                                 </Carousel.Item>
                                 <Carousel.Item>
                                     <Card style={mobileCard}>
                                         <Center>
                                             <img
                                                 className="cardImageStyle"
                                                 src={clientEleven}
                                             />
                                         </Center>
                                     </Card>

                                 </Carousel.Item>
                                 <Carousel.Item>
                                     <Card style={mobileCard}>
                                         <Center>
                                             <img
                                                 className="cardImageStyle"
                                                 src={clientTwelve}
                                             />
                                         </Center>
                                     </Card>

                                 </Carousel.Item>
                                 <Carousel.Item>
                                     <Card style={mobileCard}>
                                         <Center>
                                             <img
                                                 className="cardImageStyle"
                                                 src={clientThirteen}
                                             />
                                         </Center>
                                     </Card>

                                 </Carousel.Item>
                                 <Carousel.Item>
                                     <Card style={mobileCard}>
                                         <Center>
                                             <img
                                                 className="cardImageStyle"
                                                 src={clientFourteen}
                                             />
                                         </Center>
                                     </Card>
                                 </Carousel.Item>
                                 <Carousel.Item>
                                     <Card style={mobileCard}>
                                         <Center>
                                             <img
                                                 className="cardImageStyle"
                                                 src={clientFivteen}
                                             />
                                         </Center>
                                     </Card>

                                 </Carousel.Item>
                                 <Carousel.Item>
                                     <Card style={mobileCard}>
                                         <Center>
                                             <img
                                                 className="cardImageStyle"
                                                 src={clientSixteen}
                                             />
                                         </Center>
                                     </Card>

                                 </Carousel.Item>
                             </Carousel>
                        <Margin top={4}></Margin>
                    </Col>
                    <Col span={3}></Col>
                </Row>
            </div>
          );
};

export default Clients;
